import { Injectable } from '@angular/core';
import { TemplateMergeField } from '../../models/TemplateMergeField';
import { MergeFieldContent } from '../../enums/merge-field-content';
import { Practice } from '../../models/Practice';
import { Client } from '../../models/Client';
import { Patient } from '../../models/Patient';

@Injectable({
  providedIn: 'root'
})
export class PlaceholderService {
  constructor() {}

  getMergeFieldReplacement(
    mergeField: TemplateMergeField,
    placeholders: { placeholderId: string; replacement: string }[],
    practice?: Practice | null,
    patient?: Patient | null,
    client?: Client | null
  ): string {
    const userReplacement = placeholders.find(
      (p) => p.placeholderId === mergeField.id.toString()
    )?.replacement;
    
    if (userReplacement !== undefined && userReplacement.trim() !== '') {
      return userReplacement;
    }
    
    switch (mergeField.content) {
      case MergeFieldContent.PracticeName:
        return (
          practice?.name ||
          mergeField.placeholder
        );

      case MergeFieldContent.ClientName:
        return (
          client?.fullName ||
          mergeField.placeholder
        );

        case MergeFieldContent.ClientPostcode:
        return (
          client?.postcode ||
          mergeField.placeholder
        );

        case MergeFieldContent.ClientTitle:
        return (
          client?.title ||
          mergeField.placeholder
        );

        case MergeFieldContent.ClientBalance:
        if (client?.accountStatus !== undefined && client?.accountStatus !== null) {
          const balance = parseFloat(client.accountStatus).toFixed(2);
          return `£${balance}`;
        }
        return (
          mergeField.placeholder
        );

        case MergeFieldContent.ClientFirstName:
        return (
          client?.firstName ||
          mergeField.placeholder
        );

        case MergeFieldContent.ClientLastName:
        return (
          client?.lastName ||
          mergeField.placeholder
        );

        case MergeFieldContent.PatientName:
        return (
          patient?.name ||
          mergeField.placeholder
        );

      case MergeFieldContent.PracticePhone:
        return (
          practice?.phoneNumber ||
          mergeField.placeholder
        );

      case MergeFieldContent.PracticeEmail:
        return (
          practice?.email ||
          mergeField.placeholder
        );

      case MergeFieldContent.PracticeWebsite:
        return (
          practice?.websiteUrl ||
          mergeField.placeholder
        );

      case MergeFieldContent.AppointmentInformation:
        return (
          mergeField.placeholder
        );

      case MergeFieldContent.ProductInformation:
        return (
          placeholders.find((p) => p.placeholderId === mergeField.id.toString())?.replacement ||
          mergeField.placeholder
        );

      case MergeFieldContent.Custom:
        return (
          placeholders.find((p) => p.placeholderId === mergeField.id.toString())?.replacement ||
          mergeField.placeholder
        );

      default:
        return mergeField.placeholder;
    }
  }

  replacePlaceholders(
    text: string,
    mergeFields: TemplateMergeField[],
    placeholders: { placeholderId: string; replacement: string }[],
    practice?: Practice | null,
    patient?: Patient | null,
    client?: Client | null
  ): string {
    mergeFields.forEach((mergeField) => {
      text = text.replace(
        mergeField.placeholder,
        this.getMergeFieldReplacement(mergeField, placeholders, practice, patient, client)
      );
    });

    return text;
  }
}
